// @flow
import { createHashFromHref } from "../../utils/helpers/createHash";

import ContentLinkModel from "../content/ContentLinkModel";
import Href from "../href/Href";
import { getBasePathModularUI } from "../../constants";

import LinkCollection from "../links/LinkCollection";
import type { ModelOptions, SectionFragment } from "../types";

/**
 */
class SourceReferenceModel {
  _sourceReference: Object;
  _entryDate: ?ISO_DATE;
  _modelOptions: ModelOptions;

  /**
   */
  constructor(
    sourceReference: Object,
    entryDate: ?ISO_DATE = null,
    modelOptions?: ModelOptions,
  ) {
    this._sourceReference = sourceReference;
    this._entryDate = entryDate;
    this._modelOptions = modelOptions || {
      origin: "",
      contextPath: getBasePathModularUI(),
    };
  }

  /**
   */
  get links(): LinkCollection {
    return new LinkCollection(
      this._sourceReference._links,
      null,
      this._modelOptions,
    );
  }

  /**
   */
  get link(): ContentLinkModel {
    const section =
      this.sectionId ||
      this._sourceReference._links.self.href.replace(
        `${this._sourceReference._links.content.href}/`,
        "",
      );

    return new ContentLinkModel(
      {
        ...this._sourceReference,
        section,
      },
      this._entryDate,
      this._modelOptions,
    );
  }

  /**
   */
  get selfhref(): Href {
    return this.link.selfhref;
  }

  /**
   */
  get type(): string {
    return this._sourceReference.type;
  }

  /**
   */
  get typeLabel(): string {
    return this._sourceReference.typeLabel;
  }

  /**
   */
  get number(): string {
    return this._sourceReference.number;
  }

  /**
   */
  get label(): string {
    return this._sourceReference.label;
  }

  /**
   */
  get sourceLabel(): string {
    return this._sourceReference.sourceLabel;
  }

  /**
   *
   */
  get sourceAbbreviation(): string {
    return this._sourceReference.sourceAbbreviation;
  }

  /**
   */
  get referenceHash(): number {
    return createHashFromHref(this.selfhref);
  }

  /**
   */
  get sectionId(): string {
    return this._sourceReference.sectionId;
  }

  /**
   *
   */
  get fragment(): SectionFragment | void {
    return this._sourceReference.sectionFragment;
  }
}

export default SourceReferenceModel;
